<!--
  +---------------------------------------------------------------------------------------
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     增值开通页面
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="flex-center">



  </div>
</template>

<script>
import { moduleOpenStatus } from '@/api/common/moduleApi'
import { eiAgreementTplApi } from '@/api/ei/eiApi'

export default {
  name: 'Ei',

  data () {
    return {
      status: null
    }
  },
  created () {
    this.$store.dispatch('getUserInfoAction').then((res) => {
    }).catch(() => {
    })
    this.fetchData()
  },

  methods: {
    fetchData () {
      moduleOpenStatus({ module: 'Ei' }).then(res => {
        if (!res.errno) {
          this.status = res.data.god_module.status || 0

          // 若模块已开通，提示后，刷新页面
          if (this.status === 1) {
            this.$message({
              message: '模块开通成功',
              type: 'success',
              onClose () {
                window.location.reload()
              }
            })
          }else {
            this.$router.push('/home/upgrade')
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

  }
}
</script>
